import { render, staticRenderFns } from "./SectionTops.vue?vue&type=template&id=32d0a4e2&scoped=true&"
import script from "./SectionTops.vue?vue&type=script&lang=js&"
export * from "./SectionTops.vue?vue&type=script&lang=js&"
import style0 from "./SectionTops.vue?vue&type=style&index=0&id=32d0a4e2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32d0a4e2",
  null
  
)

export default component.exports